import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Play = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 5.10163V10.8983L11.0062 7.99996L6 5.10163ZM4.5 4.23441V11.7655C4.5 12.5358 5.33437 13.0169 6.00104 12.6309L12.5052 8.86538C13.1705 8.48022 13.1705 7.5197 12.5052 7.13453L6.00103 3.36898C5.33437 2.98301 4.5 3.46407 4.5 4.23441Z"
      fill="currentColor"
    />
  </Icon>
));

export default Play;
